import {style} from 'typestyle'
import * as csstips from 'csstips'

export const searchBar = style({
    position: 'relative',
    margin: '0 auto',
    backgroundColor: '#F8F8F8',
    borderRadius: 50,
    marginLeft: 15,
    marginRight: 15
})

export const searchBarContent = style({
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.centerJustified
})

export const searchIcon = style({
    width: 14,
    height: 14,
    marginRight: 10
})

export const searchBarText = style({
    fontSize: 14,
    color: 'rgba(153,153,153,0.50)',
    lineHeight: '14px',
    marginTop: 9,
    marginBottom: 9
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeSearchBar/HomeSearchBar.style.ts